import React from "react";
import { Footer } from "./footer";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Header from "@/pages/auth/header";

export function DeliveryAuth({ children }) {
  const location = useLocation();
  const path = location.pathname;

  const { t } = useTranslation("signup");

  // Default values for Signup page
  let title = t("requestAccount");
  let subtext = t("requestAccountDescription");

  // Override values based on current URL
  if (path.includes("/terms-conditions")) {
    title = t("termsConditions");
    subtext = null;
  } else if (path.includes("/privacy-policy")) {
    title = t("privacyPolicy");
    subtext = null;
  }

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">

     
      <Header/>

      {/* 2. PAGE HEADER */}
      <header className="bg-[#065C36] text-white py-8 px-4 text-center">
        <h1 className="text-2xl font-bold mb-2">
          {title}
        </h1>

        {subtext && (
          <p className="text-sm opacity-90 font-light">
            {subtext}
          </p>
        )}
      </header>

      {/* 3. MAIN CONTENT AREA */}
      <main className="flex-grow flex flex-col items-center py-10 px-4 bg-white">
        <div className="w-full max-w-5xl">
          {children}
        </div>
      </main>

      {/* 4. FOOTER */}
      <Footer />
    </div>
  );
}

export default DeliveryAuth;